import { VisuallyHidden } from '@hagerty/react-components';
import clsx from 'clsx';
import React from 'react';

import { HamburgerIcon } from '../Icons';

import styles from './Toggle.module.scss';

import type { StandardProps } from '../../types/common';

interface ToggleProps extends StandardProps {
  /**
   * Function to call when the toggle is clicked
   */
  onToggle: () => void;
}

export const Toggle = ({
  className,
  style,
  onToggle,
  testid = 'toggle',
  ...props
}: ToggleProps): JSX.Element => {
  return (
    <button
      {...props}
      type='button'
      className={clsx(styles['hds-toggle'], className)}
      style={style}
      onClick={onToggle}
      data-testid={testid}
    >
      <VisuallyHidden>Expand menu</VisuallyHidden>
      <HamburgerIcon />
    </button>
  );
};
